module.exports = __webpack_public_path__ + "img/watermark-white3.f243ca31.png";